import React, {useEffect} from "react";
import {Card, IconButton, ListItemText, Typography} from "@material-ui/core";
import ResultListItem from "./ResultListItem";
import RouterLinkSmallBtn from "../../partial/RouterLinkSmallBtn";
import TestDuration from "../../partial/TestDuration";
import theme from "../../../theme";
import StyleResultList from "./styles/StyleResultList";
import withUrlParams from "../../HOC/withUrlParams";
import i18n from 'i18next';
import {lessonTypes, testTypes} from "../../../config/constants";
import {useRecoilValue} from "recoil";
import {isOnlineState} from "../../../states/states";

const ResultList = ({results, seeResult, uuid, testCode, lessonCode, currCode}) => {
    const classes = StyleResultList();
    const testGroup = [testTypes.KIEM_TRA, testTypes.ON_TAP, testTypes.THI_CU];
    const lessonGroup = [lessonTypes.ON_TAP, lessonTypes.KT_GIUA_KY, lessonTypes.KT_CUOI_KY];
    const isOnline = useRecoilValue(isOnlineState);

    useEffect(() => {
        if (document.getElementsByClassName("button-show-result")[0]) {
            document.getElementsByClassName("button-show-result")[0].style.display = "none";
        }
    });

    return (
        <React.Fragment>
            <div style={{padding: theme.rootPadding}}>
                {results.map((result, index) => {
                    return (
                        <Card square key={index} className={classes.card}>
                            <ResultListItem disableRipple button disableGutters>
                                <ListItemText
                                    disableTypography
                                    primary=
                                        {<Typography
                                            variant="body2"
                                            style={{color: 'forestgreen'}}>{i18n.t('attempt')} {result.tryTimes}
                                        </Typography>}
                                />
                                <IconButton edge="end" className={classes.button}>
                                    {testCode && result.seeResult ?
                                        <RouterLinkSmallBtn
                                            to={isOnline
                                                ? `/result_detail?test_code=${testCode}&try_time=${result.tryTimes}&&uuid=${uuid}`
                                                : `/result?test_code=${testCode}&uuid=${uuid}`
                                            }>
                                            {i18n.t('see_result')}
                                        </RouterLinkSmallBtn>
                                        : lessonCode && seeResult ?
                                            <RouterLinkSmallBtn
                                                to={isOnline
                                                    ? `/result_detail?uuid=${uuid}&curr_code=${currCode}&lesson_code=${lessonCode}&try_time=${result.tryTimes}`
                                                    : `/result?uuid=${uuid}&curr_code=${currCode}&lesson_code=${lessonCode}`
                                                }>
                                                {i18n.t('see_result')}</RouterLinkSmallBtn> : <></>
                                    }
                                </IconButton>
                            </ResultListItem>
                            <React.Fragment>
                                {(result.viewScore == null || result.viewScore == 1)
                                    ? <Typography variant="body2" align="left">
                                        {i18n.t('test_result')}:
                                        &nbsp;{result.numberOfCorrectAnswers ? result.numberOfCorrectAnswers : 0}
                                        /
                                        {result.numberOfQuestions}
                                        &nbsp;({Math.round(((result.numberOfCorrectAnswers ? result.numberOfCorrectAnswers : 0) / (result.numberOfQuestions)) * 100)}%)
                                    </Typography>
                                    : ""}
                                <TestDuration startTime={result.studentStartTime}
                                              endTime={result.studentLastSubmitTime}
                                              align={"left"}/>
                            </React.Fragment>
                        </Card>
                    );
                })}
            </div>
        </React.Fragment>
    );
};

export default withUrlParams(ResultList);
